// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1HGwW","inner":"Footer_inner__2W9iL"};